import SkyNetObjectProfile from 'app/shared-components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from 'app/shared-components/SkyBaseDataGrid'
import domainConfig from './ServiceCentersDemo.config'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const ServiceCentersDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={domainConfig}
            featuresLists={featuresLists}
        />
    )
}

export default ServiceCentersDemoPage
